import Sidebar from "../Sidebar/Sidebar";
import ManageProfileSidebar from "./ManageProfileSidebar";
import { Outlet } from "react-router-dom";

const ManageProfileLayout = () => {
  return (
    <div className="flex h-screen">
      
      {/* Main App Sidebar */}
      <Sidebar />

      {/* Manage Profile Section */}
      <div className="flex flex-1 bg-gray-100">

        {/* Inner Profile Sidebar */}
        <ManageProfileSidebar />

        {/* Content Area */}
        <div className="flex-1 p-8 overflow-y-auto">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default ManageProfileLayout;
